import { Anchor, Stack, Text } from "@mantine/core";
import { Link } from "react-router";
import { PageHeader } from "../ui/PageHeader";
import { SectionCard } from "../ui/SectionCard";

/** A removed member (firm-model spec R14, §5.2): no firm, no AI calls. They can still
 * delete this account. */
export function DisabledNotice() {
  return (
    <Stack gap="lg" maw={640}>
      <PageHeader title="You're no longer part of a firm" />
      <SectionCard title="Your Account">
        <Text>You're no longer part of a firm on SlideBrain. Ask your admin, or delete this account.</Text>
        <Anchor component={Link} to="/account" size="sm" w="fit-content">
          Go to Account
        </Anchor>
      </SectionCard>
    </Stack>
  );
}
